import {MetricCode} from "@/features/metricDetails/api/metricDetailsModels";

export interface IMonitorViewModel {
    id: number;
    name: string;
    monitorResultsType: MonitorCriteriaTypeEnum;
    created: Date;
    deletedAt: Date | null;
    monitorCardResults: IMonitorCardResult[];
}

export interface IMonitorCardResult {
    pastDays: number;
    label: string;
    resultCount: number;
    locationCount: number;
}

export interface IMonitorConfiguration {
    //Values controlling state and function of the form
    formAction: "NONE" | "SEARCH" | "SAVE" | "EDIT" | "DELETE" | "VIEW-ONLY";

    //Values of the form itself
    name?: string;
    businessUnitId?: string;
    searchStartDate?: Date;
    searchEndDate?: Date;
    type: MonitorCriteriaTypeEnum;
    metricCriteria: IMetricCriteria[];

    //personId & employeeName are not set in the form itself, but can be set via the Trend functionality to
    //to execute a search for a specific person by Id or with a null Id and a populated name
    personId?: number;
    empName?: string;

    //Transaction specific fields
    tenderType?: TransactionTenderType[];
    orderChannel?: string[];
    hourOfDayStart?: number | null;
    hourOfDayEnd?: number | null;

    //PaidIn/PaidOut specific fields
    paidInPaidOutTypes?: string[];

    isTrendSearch: boolean;
}

export interface IMonitorFormParameters {
    measureOptions: IMonitorParameterOption[];
    channelOptions: IMonitorParameterOption[];
    transactionMetricOptions: IMonitorParameterOption[];
    locationMetricOptions: IMonitorParameterOption[];
    paidInPaidOutMetricOptions: IMonitorParameterOption[];
    typeOptions: IMonitorParameterOption[];
    hourOfDayOptions: IMonitorParameterOption[];
    booleanOptions: IMonitorParameterOption[];
}

export interface IMonitorParameterOption {
    key: number;
    text: string;
    value: string | number;
}

export interface IMetricCriteria {
    // This can ultimately be a string. We don't need to have all the MetricCodes in the front-end.
    // There is a subset of MetricCodes defined in the front-end for some drilldown functionality, etc.
    metric: MetricCode;
    measure: ComparisonMethodType;
    amount: string | boolean | number | null; // For validation purposes we set the value to string and the convert it to unformatted number value
}

// When adding new fields - Don't forget to update the back-end enum as well
export enum MonitorCriteriaTypeEnum {
    Unknown = "Unknown",
    Location = "Location",
    Employee = "Employee",
    Transaction = "Transaction",
    PaidInPaidOut = "PaidInPaidOut"
}

// When adding new fields - Don't forget to update the back-end enum as well
export enum ComparisonMethodType {
    // Comparison Method available to user
    Equal = "Equal",
    GreaterThanOrEqual = "GreaterThanOrEqual",
    LessThanOrEqual = "LessThanOrEqual",
    Between = "Between",
    NotEqual = "NotEqual"
}

// When adding new fields - Don't forget to update the back-end enum as well
export enum TransactionTenderType {
    Unknown = "Unknown",
    Cash = "Cash",
    Check = "Check",
    Coupon = "Coupon",
    CreditDebit = "CreditDebit",
    CustomerAccount = "CustomerAccount",
    GiftCard = "GiftCard",
    GiftCertificate = "GiftCertificate",
    Loyalty = "Loyalty",
    Mobile = "Mobile",
    OnlinePayment = "OnlinePayment",
    Other = "Other",
    Voucher = "Voucher",
    All = "All",
    NoTender = "NoTender"
}

export interface IChannel {
    channelCode: string;
    channelDescription: string;
}

export type MonitorInteraction = "NONE" | "SAVE" | "DELETE";
